import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/css/style.css';
import reportWebVitals from './reportWebVitals';
// import Router from './Router';
import Router from './Router copy';
import './locales/index';
import { Provider } from 'react-redux';
import store from 'redux/store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <Router />
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
